(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sany-launch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sany-countdown')) {
    const pad = (n) => String(n).padStart(2, '0');

    /** One timer for every countdown on the page. */
    const live = new Set();
    let ticking = null;
    const tick = () => {
      const now = Date.now();
      for (const el of live) el.render(now);
      if (!live.size) {
        clearInterval(ticking);
        ticking = null;
      }
    };

    class SanyCountdown extends HTMLElement {
      connectedCallback() {
        this.until = Number(this.dataset.until) * 1000;
        if (Number.isNaN(this.until)) return;
        live.add(this);
        this.render(Date.now());
        ticking ??= setInterval(tick, 1000);
      }

      disconnectedCallback() {
        live.delete(this);
      }

      render(now) {
        let left = Math.max(0, Math.floor((this.until - now) / 1000));
        const d = Math.floor(left / 86400); left -= d * 86400;
        const h = Math.floor(left / 3600); left -= h * 3600;
        const m = Math.floor(left / 60);
        const s = left - m * 60;
        const set = (part, v) => {
          const node = this.querySelector(`[data-part="${part}"]`);
          if (node) node.textContent = v;
        };
        set('d', pad(d));
        set('h', pad(h));
        set('m', pad(m));
        set('s', pad(s));
        set('compact', d > 0 ? `${d}d ${h}h` : `${pad(h)}:${pad(m)}:${pad(s)}`);
        if (this.until <= now) {
          this.classList.add('sany-launch--done');
          const done = this.querySelector('.sany-launch__done');
          if (done) done.hidden = false;
          live.delete(this);
        }
      }
    }

    customElements.define('sany-countdown', SanyCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
